import { TripFolderStats } from '../../lib/types/models/trip-folder/trip-folder'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getTripFolderStats(id: number) {
  return restApiClient
    .url(constructApiUrl(API.tripFolder.getStats.url, { id }))
    .get<TripFolderStats>()
}
